import { ReactNode, useCallback, useMemo } from 'react'
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom'
import { Modal } from '@luuna/shared'

export type NavigableModalProps = {
  children?: ReactNode,
  className?: string,
  onClose?: () => void,
}

export function NavigableModal({ children, className, onClose }: NavigableModalProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const type = useNavigationType()

  const calculatePath = useCallback((segments: string[]) => {
    const segment = segments.pop()

    if (!segment) {
      return '/'
    }

    if (segment.startsWith(':')) {
      calculatePath(segments)
    }

    return segments.join('/')
  }, [])

  const nextRouteDown = useMemo(() => calculatePath(location.pathname.split('/')), [calculatePath, location])

  const handleClose = () => {
    if (onClose) {
      return onClose()
    }

    navigate(nextRouteDown)
  }

  return (
    <Modal.Root
      onClose={handleClose}
      content={children}
    >
      <Modal.Backdrop />
      <Modal.Panel
        className={className}
        initial={type === 'PUSH' ? 'initial' : 'off'}
      />
    </Modal.Root>
  )
}

NavigableModal.Header = Modal.Header
NavigableModal.Content = Modal.Content
NavigableModal.Heading = Modal.Heading
NavigableModal.Footer = Modal.Footer
